// REL_1.1.14 F-262 / S-980 — deedo-marketing route table.
// REL_1.1.15 F-262 §2 — wrap routes with CurrencySettingsProvider for multi-currency display.
// REL_1.1.15 S-1101 v2.8 — `/us/` prefix DROPPED (hardcode-US descope, S-1100 Q1 + Architecture §C
//   structural ruling). Routes collapse to root: `/`, `/for-buyers`, `/for-agents`, `/pricing`,
//   `/about`, `/contact`. No GeoIP/country-routing (returns REL_1.2+); manual country/currency
//   override dropdown stays (localStorage-persisted). S-1108 marketing E2E asserts no `/us/` paths.
//   NOTE: `/contact` currently renders the combined About-&-Contact page (contact form lives there);
//   flagged to Business if a dedicated About/Contact content split is wanted.
import { Routes, Route, Navigate } from "react-router-dom";
import MarketingLayout from "./components/layout/MarketingLayout";
import HomePage from "./pages/HomePage";
import ForBuyers from "./pages/us/ForBuyers";
import ForAgents from "./pages/us/ForAgents";
import Pricing from "./pages/us/Pricing";
import About from "./pages/us/About";
import NotFoundPage from "./pages/NotFoundPage";
import { CountrySettingsProvider } from "./hooks/useCountrySettings";
import { CurrencySettingsProvider } from "./hooks/useCurrencySettings";
import ConsentBanner from "./components/common/ConsentBanner";

export default function App() {
  return (
    <CountrySettingsProvider>
      <CurrencySettingsProvider>
        {/* REL_1.1.15E F-311 (S-1230) — cookie-consent banner; self-hides unless GTM is active (prod). */}
        <ConsentBanner />
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/for-buyers" element={<ForBuyers />} />
            <Route path="/for-agents" element={<ForAgents />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            {/* S-1108 asserts /contact/ exists; renders the About-&-Contact page (contact form). */}
            <Route path="/contact" element={<About />} />
            {/* Back-compat: redirect any lingering /us/* deep links to the collapsed roots. */}
            <Route path="/us/for-buyers" element={<Navigate to="/for-buyers" replace />} />
            <Route path="/us/for-agents" element={<Navigate to="/for-agents" replace />} />
            <Route path="/us/pricing" element={<Navigate to="/pricing" replace />} />
            <Route path="/us/about" element={<Navigate to="/contact" replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </CurrencySettingsProvider>
    </CountrySettingsProvider>
  );
}
